import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAdminAuth } from '../../context/AdminAuthContext';
import { useSite } from '../../context/SiteContext';

export default function AdminLogin() {
    const { login, isAuthed, loading } = useAdminAuth();
    const { settings } = useSite();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [submitting, setSubmitting] = useState(false);

    if (!loading && isAuthed) return <Navigate to="/admin" replace />;

    const onSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await login(email, password);
            toast.success('Welcome back.');
            navigate('/admin');
        } catch (err) {
            toast.error(err?.response?.data?.detail || 'Invalid credentials');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: 'var(--brand-blush)' }} data-testid="admin-login-page">
            <div className="luxury-card p-10 w-full max-w-md">
                <div className="flex justify-center mb-6">
                    {settings?.logo_url && <img src={settings.logo_url} alt="by anfal" className="h-16 w-auto" />}
                </div>
                <div className="text-center mb-8">
                    <p className="eyebrow" style={{ color: 'var(--brand-burgundy)' }}>Atelier Access</p>
                    <h1 className="font-serif text-3xl mt-2" style={{ color: 'var(--brand-burgundy)' }}>Admin Sign In</h1>
                    <hr className="divider-burgundy mt-4 mx-auto" />
                </div>
                <form onSubmit={onSubmit} className="space-y-4">
                    <div>
                        <label className="eyebrow block mb-1" style={{ color: 'var(--ink-muted)' }}>Email</label>
                        <input data-testid="admin-login-email-input" required type="email" className="input-luxury" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div>
                        <label className="eyebrow block mb-1" style={{ color: 'var(--ink-muted)' }}>Password</label>
                        <input data-testid="admin-login-password-input" required type="password" className="input-luxury" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <button
                        type="submit"
                        disabled={submitting}
                        data-testid="admin-login-submit-button"
                        className="btn-burgundy w-full px-6 py-3 rounded-xl text-xs tracking-[0.22em] uppercase font-medium disabled:opacity-60 mt-2"
                    >
                        {submitting ? 'Signing in...' : 'Sign In'}
                    </button>
                </form>
            </div>
        </div>
    );
}
